const FIRST_TOUCH_STORAGE_KEY = 'crs_first_touch_v1'

export const MARKETING_KEYS = Object.freeze([
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_id',
  'gclid',
  'gbraid',
  'wbraid',
  'fbclid',
  'msclkid',
])

const clean = (value, maximum = 300) => String(value || '').replace(/\s+/g, ' ').trim().slice(0, maximum)

const safeLocation = (value) => {
  if (!value) return ''
  try {
    const url = new URL(value, window.location.origin)
    return `${url.origin === window.location.origin ? '' : url.origin}${url.pathname}`
  } catch {
    return clean(value).split('?')[0].split('#')[0]
  }
}

const readStoredFirstTouch = () => {
  try {
    const stored = JSON.parse(window.localStorage.getItem(FIRST_TOUCH_STORAGE_KEY) || 'null')
    return stored && typeof stored === 'object' ? stored : null
  } catch {
    return null
  }
}

const writeStoredFirstTouch = (value) => {
  try {
    window.localStorage.setItem(FIRST_TOUCH_STORAGE_KEY, JSON.stringify(value))
  } catch {
    // Attribution remains available for the current submission when storage is blocked.
  }
}

export function getMarketingAttribution() {
  if (typeof window === 'undefined') return {}
  const params = new URLSearchParams(window.location.search)
  const campaign = Object.fromEntries(MARKETING_KEYS.map((key) => [key, clean(params.get(key))]))
  const current = {
    ...campaign,
    landing_page: window.location.pathname,
    referrer: safeLocation(document.referrer),
  }
  const stored = readStoredFirstTouch()
  if (!stored) writeStoredFirstTouch(current)
  const firstTouch = stored || current
  return {
    ...current,
    first_landing_page: safeLocation(firstTouch.landing_page) || window.location.pathname,
  }
}

export function inferFormLocation(pathname = '') {
  if (pathname === '/contacto/' || pathname === '/contacto') return 'contact_page'
  if (pathname.startsWith('/landing')) return 'campaign_page'
  return 'site_page'
}
